import { Box } from "@chakra-ui/react";
import { colors } from "goi_common";
import { forwardRef } from "react";

import { COST_FUNNEL_INFO_STEP_COUNT } from "@/constants/parlor/costLeadFunnel";

/**
 * 퍼널 스텝 헤더. 장례식장명 + `n/4` 라벨 + 4칸 프로그레스 바.
 *
 * 정보 스텝에서 주황 배너를 화면 위로 밀어낸 뒤에도 진행 상황이 계속 보이게 하는 것이
 * 이 sticky 의 목적이다.
 *
 * ⚠️ `topOffset` 은 위에 깔린 글로벌 헤더 높이다. 퍼널 페이지는 헤더가 있어 `HEADER_HEIGHT`,
 * `/login` 은 Layout 이 헤더를 숨기는 라우트라 0 이다. 이 값이 틀리면 위쪽에 빈 띠가 생긴다.
 *
 * ⚠️ sticky 는 조상 중 `overflow: hidden` 이 있으면 무력화된다. 부모 스택에 overflow 를
 * 걸지 말 것 (기존 견적 폼의 sticky 게이지에서 겪은 문제).
 */
const CostFunnelStepHeader = forwardRef<
  HTMLDivElement,
  {
    parlorName: string;
    /**
     * 0-based 정보 스텝 인덱스. 이 값 이하의 칸이 활성.
     * `null` 이면 리드 제출 화면이라 스텝 라벨과 프로그레스 바를 숨기고 타이틀만 남긴다.
     */
    stepIndex: number | null;
    /** 위에 깔린 글로벌 헤더 높이(px). 헤더가 없는 라우트는 0 */
    topOffset: number;
  }
>(function CostFunnelStepHeader({ parlorName, stepIndex, topOffset }, ref) {
  return (
    <Box
      ref={ref}
      position="sticky"
      top={`${topOffset}px`}
      zIndex={5}
      width="100%"
      background={colors.white}
      borderBottom={`1px solid ${colors.gray200}`}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        gap="12px"
        padding="14px 20px 10px"
      >
        <Box className="subtitle_14_b" color={colors.gray900} css={{ minWidth: 0 }} isTruncated>
          {parlorName} 비용 안내
        </Box>
        {stepIndex !== null && (
          <Box
            className="caption_12_sb"
            color={colors.gray500}
            flexShrink={0}
            css={{ letterSpacing: 0 }}
          >
            {stepIndex + 1}/{COST_FUNNEL_INFO_STEP_COUNT}
          </Box>
        )}
      </Box>
      {stepIndex !== null && (
        <Box display="flex" gap="4px" padding="0 20px 12px">
          {Array.from({ length: COST_FUNNEL_INFO_STEP_COUNT }).map((_, index) => (
            <Box
              key={index}
              height="3px"
              flex={1}
              borderRadius="9999px"
              background={index <= stepIndex ? colors.orange650 : colors.gray200}
            />
          ))}
        </Box>
      )}
    </Box>
  );
});

export default CostFunnelStepHeader;
